<template>
    <v-container>
        <create-registration-link
            @create="$refs.list.update()"
        ></create-registration-link>

        <registration-link-list
            @qrcode="$refs.viewerDialog.show($event)"
            ref="list"
        ></registration-link-list>

        <registration-link-viewer-dialog
            ref="viewerDialog"
        ></registration-link-viewer-dialog>
    </v-container>
</template>

<script>
import CreateRegistrationLink from './components/CreateRegistrationLink.vue'
import RegistrationLinkList from './components/RegistrationLinkList.vue'
import RegistrationLinkViewerDialog from './components/RegistrationLinkViewerDialog.vue'

export default {
    components: {
        CreateRegistrationLink,
        RegistrationLinkList,
        RegistrationLinkViewerDialog,
    }
}
</script>
